// extracted by mini-css-extract-plugin
module.exports = {"background":"App_fasting_background__4Hr9s"};